import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {Header, Tabs} from '@/components';
import type {TabItem} from '@/types';
import {logger} from '@/utils/logger';

import Settings from './Settings';
import Summary from './Summary';
import useCurrencyUpdate from './useCurrencyUpdate';

const Details = () => {
  const params = useParams();
  const currencyId = params?.currencyCode || '';
  const {isLoading, item, handleUpdate, fetchItem} = useCurrencyUpdate();

  useEffect(() => {
    if (currencyId) {
      // `fetchItem` try/catches into showErrorMessage, so this only fires if
      // that reporting itself threw. Attached because an unhandled rejection
      // would leave the Settings tab editing an empty currency, and that tab
      // writes this currency's processor routing; dev logger rather than a
      // second toast, since a toast is what just failed.
      fetchItem(currencyId).catch(logger.error);
    }
  }, [currencyId, fetchItem]);

  const tabs: TabItem[] = [
    {
      id: 'general',
      title: 'General',
      content: <Summary item={item} />,
    },

    {
      id: 'settings',
      title: 'Settings',
      content: (
        <Settings handleSave={handleUpdate} item={item} fetching={isLoading} />
      ),
    },
  ];
  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={`${item?.name || ''} Settings`} />
      <Tabs key={isLoading?.toString()} tabs={tabs} queryKey={'tab'} />
    </main>
  );
};
export default Details;
